import { render, staticRenderFns } from "./Questiongrouptemplate.vue?vue&type=template&id=2932076d&scoped=true"
import script from "./Questiongrouptemplate.vue?vue&type=script&lang=js"
export * from "./Questiongrouptemplate.vue?vue&type=script&lang=js"
import style0 from "./Questiongrouptemplate.vue?vue&type=style&index=0&id=2932076d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2932076d",
  null
  
)

export default component.exports